import { Button } from "@tblabs/truffle";
import { Svg } from "./Utils/Svg";


export class AuthButton extends Button
{
    constructor()
    {
        super("");

        this.OnClick(() => window.location.hash = "login");

        this.Append(
            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart navbar__icon"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="10" r="3"/><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"/></svg>`)
        );
    }
}
